module.exports = __webpack_public_path__ + "img/woman.b39bc776.png";